"use strict";
/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
Object.defineProperty(exports, "__esModule", { value: true });
exports.ArrowCUpIcon64Regular = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var forwardRef_1 = require("../../helpers/forwardRef");
var BaseIcon_1 = require("../../internal/BaseIcon");
exports.ArrowCUpIcon64Regular = forwardRef_1.forwardRef('ArrowCUpIcon64Regular', function (props, ref) {
    return (react_1.default.createElement(BaseIcon_1.BaseIcon, tslib_1.__assign({ ref: ref, viewBoxSize: 64 }, props),
        react_1.default.createElement("path", { d: "M9.94 42.06a1.5 1.5 0 0 1 0-2.12l16.757-16.758a7.5 7.5 0 0 1 10.606 0l16.758 16.757a1.5 1.5 0 0 1-2.122 2.122L35.182 25.303a4.5 4.5 0 0 0-6.364 0L12.061 42.061a1.5 1.5 0 0 1-2.122 0Z" })));
});
